/**
 * Sticky-Bar: Button „Direkt zum Checkout“ — nutzt Variante + Menge aus dem Produktformular.
 */
(function () {
  if (window.__rfStickyAtcCheckoutBound) return;
  window.__rfStickyAtcCheckoutBound = true;

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-sticky-atc-checkout]');
    if (!btn || btn.disabled) return;

    const formId = btn.getAttribute('data-product-form-id');
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) return;

    event.preventDefault();

    const idInput = form.querySelector('[name="id"]');
    const variantId = idInput && idInput.value;
    if (!variantId) return;

    let qtyField = null;
    if (form.elements && typeof form.elements.namedItem === 'function') {
      qtyField = form.elements.namedItem('quantity');
    }
    if (!qtyField) {
      qtyField = document.querySelector('input[name="quantity"][form="' + formId.replace(/"/g, '') + '"]');
    }
    let qty = (qtyField && qtyField.value) || '1';
    qty = String(parseInt(qty, 10) || 1);

    const cartBase = (window.routes && window.routes.cart_url) || '/cart';
    const origin = window.shopUrl || '';
    const path = cartBase.startsWith('http') ? cartBase : origin + cartBase;
    window.location.href = `${path.replace(/\/$/, '')}/${variantId}:${qty}?checkout`;
  });
})();
